import Axios from 'axios';
import {FileRejection} from 'react-dropzone';

import {updateFileProgress, startFileUpload, finishFileUpload, failureFileUpload} from 'ducks/FileUpload';
import {getApiUrl} from 'shared/APIServices/utils';
import getStore from 'store';
import {UploadedFileData, UploadedFileObject} from 'types/FileUpload';
import {
  NOT_FOUND_STATUS_CODE,
  SERVER_ERROR_STATUS_CODE,
  FORBIDDEN_STATUS_CODE,
  SERVICE_UNAVAILABLE_STATUS_CODE
} from 'utils/error';

const buildHomePhotoFormData = ({file}: {file: File}) => {
  const homePhoto = {};
  const formData = new FormData();
  formData.append('file', file);
  formData.append(
    'homePhoto',
    new Blob([JSON.stringify(homePhoto)], {
      type: 'application/json'
    })
  );
  return formData;
};

const getContentURL = (photoId: string, claimsFileNumber: string): URL =>
  new URL(`${getApiUrl()}/home-photos/${photoId}/claims/${claimsFileNumber}/files`);

export const uploadFile = async (photoId: string, claimsFileNumber: string, file: File): Promise<any> => {
  const store = getStore();
  const fileId = `${file.name}:${Number(file.size)}`;
  let uploadPercentage: number = 0;
  store.dispatch(startFileUpload(fileId, uploadPercentage));

  return await Axios.post(
    getContentURL(photoId, claimsFileNumber).toString(),
    buildHomePhotoFormData({
      file
    }),
    {
      headers: {
        'Amica-Agent': 'Amica-Web',
        'accept-language': 'en_US'
      },
      onUploadProgress: (progressEvent) => {
        const loaded: number = progressEvent.loaded;
        const total = progressEvent.total;

        uploadPercentage = total ? Math.round((loaded * 100) / total) : 0;
        store.dispatch(updateFileProgress(fileId, uploadPercentage));
      }
    }
  )
    .then((response) => {
      store.dispatch(finishFileUpload(fileId, uploadPercentage, response.data));
    })
    .catch((error) => {
      store.dispatch(failureFileUpload(fileId, error.response));
    });
};

export const isFileAlreadyLoaded = (uploadedFiles: UploadedFileData[], newFile: UploadedFileObject) =>
  uploadedFiles.some(
    (uploadedFile) =>
      uploadedFile.originalFilename === newFile.fileData.originalFilename && uploadedFile.size === newFile.fileData.size
  );

export const isFileAlreadyLoadedByFileId = (uploadedFiles: UploadedFileData[], newFile: UploadedFileObject) =>
  uploadedFiles.some((uploadedFile) => newFile.fileId === uploadedFile.originalFilename + ':' + uploadedFile.size);

export const isNewlyAddedFile = (fileID: string) => fileID.indexOf(':') > -1;

const apiErrorStatusCodes = [
  FORBIDDEN_STATUS_CODE,
  NOT_FOUND_STATUS_CODE,
  SERVER_ERROR_STATUS_CODE,
  SERVICE_UNAVAILABLE_STATUS_CODE
];

export const shouldDisplayErrorBanner = (errors: Array<number | null>) =>
  errors.some((error) => !!error && apiErrorStatusCodes.includes(error));

export const getRejectedFiles = (fileRejections: FileRejection[]) =>
  fileRejections.map((fileRejection: FileRejection) => fileRejection.file);
